import { Tooltip } from "@material-tailwind/react";

export interface Option {
  color: string;
  amount: number;
  percentage: number;
  key: string;
}

export interface StackedProgressBarProps {
  title: string;
  options: Option[];
  legend: {
    [key: string]: string;
  };
  width?: string;
  className?: string;
  tooltip: (option: Option) => string;
}

export const StackedProgressBar = ({
  title,
  legend,
  options,
  width = "w-[100px]",
  className = "",
  tooltip,
}: StackedProgressBarProps) => {
  return (
    <div className={className}>
      <div className="flex flex-col gap-2">
        <div className=" text-sm">{title}</div>
        <div className="relative px-[20px] ">
          <div
            className={`overflow-hidden h-3 mb-2 text-xs flex outline outline-1 outline-gray-200 flex-row rounded-sm bg-gray-200 ${width}`}
          >
            {options &&
              options.map((option) => {
                return (
                  <Tooltip
                    key={option.key}
                    placement="top"
                    content={tooltip(option || "")}
                    className="relative capitalize"
                  >
                    <div
                      key={option.key}
                      style={{
                        width: `${option.percentage}%`,
                        background: option.color,
                      }}
                      className={`shadow-none text-center whitespace-nowrap text-white justify-center`}
                    ></div>
                  </Tooltip>
                );
              })}
          </div>
        </div>
      </div>
      <div className="flex flex-row flex-wrap gap-x-7 gap-y-2 w-[80%] px-[20px]">
        {options &&
          options.map((option) => {
            return (
              <div
                className="flex flex-row gap-2 items-center"
                key={option.key}
              >
                <div
                  className={`w-[10px] h-[10px] rounded-md`}
                  style={{
                    backgroundColor: option.color,
                  }}
                ></div>

                <span
                  className={
                    " text-gray-600 text-xs font-bold    " +
                    (option.key === "DLA" ? "uppercase" : "capitalize")
                  }
                >
                  {` ${option.key.toLowerCase().replace("_", " ")}:`}
                </span>
                <span className={" text-gray-600 text-xs font-bold    "}>
                  {`${option.amount} ${option.amount == 1 ? "Unit" : "Units"}`}
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default StackedProgressBar;
